export default {
  title: 'Points et remises',
  store_credit: 'Crédit boutique',
  points_balance: 'Solde de points',
};
